import { Field, FormikProps } from "formik";
import React, { FC } from "react";

import { getApiError, getLocalError, isErrorVisible } from "@/formikComponents/service";

import { FormError, OverrideMessages } from "../errors";

interface FormikErrorProps {
  name: string;
  overrideMessages?: OverrideMessages;
}

export const FormikError: FC<FormikErrorProps> = ({ name, overrideMessages }) => {
  return (
    <Field name={name}>
      {({ form }: { form: FormikProps<unknown> }) => {
        const visible = isErrorVisible(form, name);

        if (!visible) {
          return null;
        }

        const apiError = getApiError(form, name);
        const localError = getLocalError(form, name);

        return <FormError error={apiError || localError} overrideMessages={overrideMessages} />;
      }}
    </Field>
  );
};
